<template>
  <FullScreenLayout>
    <div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
      <div
        class="relative flex lg:flex-row w-full h-screen justify-center flex-col dark:bg-gray-900"
      >
        
        <div
          class="auth-logo-container"
        >
          <div class="items-center justify-center flex z-1">
            <common-grid-shape />
            <div class="flex flex-col items-center max-w-xs">
              <router-link to="/" class="block mb-4">
                <img width="{231}" height="{48}" src="/images/logo/logo-light.svg" alt="Logo" />
              </router-link>
            </div>
          </div>
        </div>


        <div class="flex flex-col flex-1 lg:w-1/2 w-full">
          <!-- Form -->
          <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
            <div class="mb-5 sm:mb-8">
              <h1
                class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md"
                v-if="props.title"
              >
                {{ props.title }}
              </h1>
              <p class="text-sm text-gray-500 dark:text-gray-400" v-if="props.description">
                {{ props.description }}
              </p>
            </div>

            <!-- Slot for form content -->
            <slot></slot>

          </div>
        </div>


      </div>
    </div>
  </FullScreenLayout>
</template>

<script setup lang="ts">
const props = defineProps(['title', 'description'])
import CommonGridShape from '@/components/common/CommonGridShape.vue'
import FullScreenLayout from '@/components/layout/FullScreenLayout.vue'
import { RouterLink } from 'vue-router'
</script>
